import { styled } from "@mui/material";

export const OneRepMaxTooltipCardRowLabel = styled("div")({
  display: "flex",
  alignItems: "center",
});
